import { Component, EventEmitter, Input, Output } from '@angular/core'
import { trigger, transition, style, animate } from '@angular/animations'

@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './delete-confirm-modal.component.html',
  styleUrls: ['./delete-confirm-modal.component.scss'],
  animations: [
    trigger('backdropAnim', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('180ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('cardAnim', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.92) translateY(-12px)' }),
        animate('220ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('180ms ease-in', style({ opacity: 0, transform: 'scale(0.92) translateY(-12px)' }))
      ])
    ])
  ]
})
export class DeleteConfirmModalComponent {
  /** Controls modal visibility */
  @Input() visible: boolean = false

  /** Name of the item being deleted — shown in bold in the message */
  @Input() itemName: string = ''

  /**
   * Label used in the title and confirm button.
   * e.g. "Coupon" → "Delete Coupon" / "Product" → "Delete Product"
   */
  @Input() itemType: string = 'Item'

  /** Emitted when the user clicks "Delete" */
  @Output() confirmed = new EventEmitter<void>()

  /** Emitted when the user clicks "Cancel" or the backdrop */
  @Output() cancelled = new EventEmitter<void>()

  onConfirm() {
    this.confirmed.emit()
  }

  onCancel() {
    this.cancelled.emit()
  }
}
